import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  textButton: {
    borderRadius: 10,
    marginRight: 10,
    padding: 5,
    cursor: 'pointer',
    border: '1px solid #ccc',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.1)',
    },
    textAlign: 'center',
  },
}));

// Tooltip için ayrı stil objesi
export const noteTooltipStyles = {
  fontSize: '0.875rem',
  fontWeight: 500,
  backgroundColor: 'background.paper',
  color: 'text.primary',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 2,
  boxShadow: (theme: any) =>
    theme.palette.mode === 'dark'
      ? '0 8px 32px rgba(0,0,0,0.4)'
      : '0 8px 32px rgba(0,0,0,0.12)',
  maxWidth: 280,
  minWidth: 120,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  padding: '8px 12px',
  backdropFilter: 'blur(8px)',
  '& .MuiTooltip-arrow': {
    color: 'background.paper',
    '&::before': {
      border: '1px solid',
      borderColor: 'divider',
    },
  },
};

// Chip için stil objesi
export const noteChipStyles = {
  fontSize: '0.8rem',
  fontWeight: 'bold',
  height: 20,
  paddingTop: '4px',
};

// Chip için "YOK" durumu stilleri
export const noteChipEmptyStyles = {
  color: 'text.secondary',
  borderColor: 'divider',
  backgroundColor: 'transparent',
};
